import React from 'react';
export const Camping = () => (
  <svg width="151px" height="109px" viewBox="0 0 151 109" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-808.000000, -1683.000000)">
        <g transform="translate(809.000000, 1683.000000)">
          <path
            d="M135.2564,106.8451 L145.6284,106.8451"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.9459,106.8451 L0.1049,106.8451"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(28.000000, 54.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.2173 53.0795 62.2033 52.7355 29.7173 0.0035 16.8913 23.0795"
            />
            <polyline
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.2173 53.0795 62.2033 52.7355 29.7173 0.0035 16.8913 23.0795"
            />
          </g>
          <g transform="translate(28.000000, 80.710000)">
            <path d="M15.0621,0.3695 L0.2171,27.0795" fill="#FFFFFF" />
            <path
              d="M15.0621,0.3695 L0.2171,27.0795"
              stroke="#D71385"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#DDE5E8"
            points="58.0704 86.1352 70.8184 106.8452 58.0704 106.8452"
          />
          <g transform="translate(57.000000, 54.710000)">
            <polyline
              fill="#FAFBFD"
              points="44.5601 17.6263 67.1431 52.1353 33.2041 52.7353 0.7171 0.0033 33.2041 0.2723 40.6731 11.6863"
            />
            <polyline
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="44.5601 17.6263 67.1431 52.1353 33.2041 52.7353 0.7171 0.0033 33.2041 0.2723 40.6731 11.6863"
            />
          </g>
          <path
            d="M131.4673,106.8451 C131.4013,104.1911 129.3243,101.9651 126.6093,101.7591 C125.7353,101.6941 124.8953,101.8451 124.1423,102.1671 C122.9673,98.9751 120.0103,96.5921 116.3843,96.3181 C111.8723,95.9761 107.8873,99.0171 106.9353,103.2911 C106.9053,103.2881 106.8743,103.2821 106.8433,103.2811 C104.7793,103.1241 102.9793,104.6631 102.8223,106.7191 C102.8193,106.7611 102.8213,106.8031 102.8193,106.8451 L131.4673,106.8451 Z"
            fill="#5EDAB0"
          />
          <path
            d="M106.2574,106.8451 L131.4674,106.8451 C131.4014,104.1911 129.3244,101.9651 126.6094,101.7591 C125.7354,101.6941 124.8954,101.8451 124.1424,102.1671"
            stroke="#005239"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.3848,96.3178 C111.8728,95.9758 107.8878,99.0168 106.9358,103.2918 C106.9048,103.2888 106.8748,103.2828 106.8428,103.2808 C104.7798,103.1248 102.9788,104.6638 102.8218,106.7188 C102.8198,106.7608 102.8208,106.8028 102.8198,106.8448"
            stroke="#005239"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.7169,57.7133 L57.7169,106.3223"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M25.8214,13.4672 C24.4374,9.1162 25.7414,4.5632 28.7944,1.5722 C27.3394,1.5322 25.8544,1.7172 24.3884,2.1842 C17.3784,4.4142 13.5034,11.9062 15.7334,18.9172 C17.9644,25.9292 25.4564,29.8042 32.4674,27.5722 C35.9134,26.4762 38.5964,24.1052 40.1744,21.1482 C34.1194,22.8842 27.7434,19.5092 25.8214,13.4672"
            fill="#FFFFFF"
          />
          <path
            d="M25.8214,13.4672 C24.4374,9.1162 25.7414,4.5632 28.7944,1.5722 C27.3394,1.5322 25.8544,1.7172 24.3884,2.1842 C17.3784,4.4142 13.5034,11.9062 15.7334,18.9172 C17.9644,25.9292 25.4564,29.8042 32.4674,27.5722 C35.9134,26.4762 38.5964,24.1052 40.1744,21.1482 C34.1194,22.8842 27.7434,19.5092 25.8214,13.4672 Z"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(5.000000, 19.710000)">
            <path
              d="M21.2657,5.3998 C20.2367,4.4088 18.8917,4.6298 18.8917,4.6298 C18.8917,4.6298 19.4457,2.1778 15.8047,1.0628 C12.1637,-0.0522 10.5807,2.3018 10.5807,2.3018 C8.6027,0.8158 7.0987,2.5498 6.3867,3.6658 C5.6747,4.7808 5.1197,5.8958 2.8247,6.1438 C0.5297,6.3908 0.2917,8.4978 0.2917,8.4978 L24.9927,8.4978"
              fill="#FFFFFF"
            />
            <path
              d="M21.2657,5.3998 C20.2367,4.4088 18.8917,4.6298 18.8917,4.6298 C18.8917,4.6298 19.4457,2.1778 15.8047,1.0628 C12.1637,-0.0522 10.5807,2.3018 10.5807,2.3018 C8.6027,0.8158 7.0987,2.5498 6.3867,3.6658 C5.6747,4.7808 5.1197,5.8958 2.8247,6.1438 C0.5297,6.3908 0.2917,8.4978 0.2917,8.4978 L24.9927,8.4978"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M66.8184,18.3402 C66.8184,19.2702 66.0654,20.0232 65.1364,20.0232 C64.2074,20.0232 63.4544,19.2702 63.4544,18.3402 C63.4544,17.4112 64.2074,16.6582 65.1364,16.6582 C66.0654,16.6582 66.8184,17.4112 66.8184,18.3402"
            fill="#FFFFFF"
          />
          <path
            d="M66.8184,18.3402 C66.8184,19.2702 66.0654,20.0232 65.1364,20.0232 C64.2074,20.0232 63.4544,19.2702 63.4544,18.3402 C63.4544,17.4112 64.2074,16.6582 65.1364,16.6582 C66.0654,16.6582 66.8184,17.4112 66.8184,18.3402 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M113.067,30.434 C113.067,31.363 112.314,32.117 111.385,32.117 C110.456,32.117 109.703,31.363 109.703,30.434 C109.703,29.505 110.456,28.752 111.385,28.752 C112.314,28.752 113.067,29.505 113.067,30.434"
            fill="#FFFFFF"
          />
          <path
            d="M113.067,30.434 C113.067,31.363 112.314,32.117 111.385,32.117 C110.456,32.117 109.703,31.363 109.703,30.434 C109.703,29.505 110.456,28.752 111.385,28.752 C112.314,28.752 113.067,29.505 113.067,30.434 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.8184,0.8852 L89.8184,2.8852"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M89.8184,6.8852 L89.8184,8.8852"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M93.8184,4.8852 L91.8184,4.8852"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M87.8184,4.8852 L85.8184,4.8852"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M16.6422,42.7494 L16.6422,44.7494"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M16.6422,48.7494 L16.6422,50.7494"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M20.6422,46.7494 L18.6422,46.7494"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M14.6422,46.7494 L12.6422,46.7494"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <g transform="translate(24.000000, 58.710000)">
            <polyline
              fill="#FFFFFF"
              points="7.7247 35.1332 7.7247 24.5412 0.1027 24.5412 8.1927 11.2112 4.2177 11.2112 12.1687 0.0032 15.8097 3.6442"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="7.7247 35.1332 7.7247 24.5412 0.1027 24.5412 8.1927 11.2112 4.2177 11.2112 12.1687 0.0032 15.8097 3.6442"
            />
          </g>
          <path
            d="M81.8184,86.1352 L107.2694,86.1352"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#DDE5E8"
            points="72.9576 57.8871 75.7286 62.7591 86.6796 62.7591 83.6796 57.8871"
          />
          <g transform="translate(99.000000, 41.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.4493 23.0033 10.6023 11.2223 20.7203 21.9643 39.4893 0.0393 50.2483 11.5213"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.4493 23.0033 10.6023 11.2223 20.7203 21.9643 39.4893 0.0393 50.2483 11.5213"
            />
          </g>
          <g transform="translate(131.000000, 48.710000)">
            <path
              d="M0.4673,1.2416 C0.4673,1.2416 0.5673,2.5496 3.6283,3.5356 C6.6893,4.5206 7.6573,0.4736 10.4423,0.4736 C13.2273,0.4736 15.8903,2.0046 15.8903,2.0046"
              fill="#FFFFFF"
            />
            <path
              d="M0.4673,1.2416 C0.4673,1.2416 0.5673,2.5496 3.6283,3.5356 C6.6893,4.5206 7.6573,0.4736 10.4423,0.4736 C13.2273,0.4736 15.8903,2.0046 15.8903,2.0046"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(105.000000, 57.710000)">
            <path
              d="M0.3321,0.1771 C0.3321,0.1771 2.0891,2.6131 3.6021,2.6131 C5.1151,2.6131 5.4951,1.3951 7.0631,1.3951 C8.6321,1.3951 10.3651,2.6131 11.6391,2.6131"
              fill="#FFFFFF"
            />
            <path
              d="M0.3321,0.1771 C0.3321,0.1771 2.0891,2.6131 3.6021,2.6131 C5.1151,2.6131 5.4951,1.3951 7.0631,1.3951 C8.6321,1.3951 10.3651,2.6131 11.6391,2.6131"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
